import React, { Fragment } from 'react';
import './investors.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';


const InvestTransition = () => {
  return (
    <div className='transition-container'>
      <div className='transition-title'>Rideshare Market Transition</div>
      <div className='transition-content'>

        <div className='transition-stage'>

          <div className='transition-level'>
            Rideshare companies
            <div className='transition-role'>
              Dispatch
            </div>
          </div>

          <div className='transition-level'>
            Drivers
            <div className='transition-role'>
              Vehicle control
            </div>
            <div className='transition-role'>
              Driving
            </div>
          </div>
        
          <div className='transition-level'>
            Vehicle OEM
            <div className='transition-role'>
              Vehicle production
            </div>
          </div>

        </div>

        <FontAwesomeIcon icon={faChevronRight}/>

        <div className='transition-stage-current'>
          
          <div className='transition-level'>
            Rideshare companies
            <div className='transition-role'>
              Dispatch
            </div>
          </div>

          <div className='transition-level-autzu'>
            Autzu
            <div className='transition-role-autzu'>
              Vehicle control
            </div>
          </div>

          <div className='transition-level'>
            Drivers
            <div className='transition-role'>
              Driving
            </div>
          </div>
        
          <div className='transition-level'>
            Vehicle OEM
            <div className='transition-role'>
              Vehicle production
            </div>
          </div>

          <span className='current-state'>Current state</span>

        </div>

        <FontAwesomeIcon icon={faChevronRight}/>

        <div className='transition-stage'>

          <div className='transition-level'>
            Rideshare companies
            <div className='transition-role'>
              Dispatch
            </div>
          </div>

          <div className='transition-level-autzu'>
            Autzu
            <div className='transition-role-autzu'>
              Vehicle control
            </div>
          </div>

          <div className='transition-level'>
            Vehicle OEM
            <div className='transition-role'>
              Autonomous driving
            </div>
            <div className='transition-role'>
              Vehicle production
            </div>
          </div>

        </div>
     
      </div>
    </div>
  );
};

export default InvestTransition;



// WEBPACK FOOTER //
// ./src/components/Investors/InvestInTransition.js